import "react-toastify/dist/ReactToastify.css";
import "./chatstyles.css";
import Heatmap from "highcharts/modules/heatmap";
import Highcharts from "highcharts";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsReact from "highcharts-react-official";
import React, { useRef, useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

// import { data } from './data.js';

import {
  Button,
  Card,
  CardBody,
  CardText,
  Col,
  Container,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from 'reactstrap';

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

// Initialize the heatmap module
Heatmap(Highcharts);

const Inbox = () => {
  document.title = 'Webinar';
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;
  console.warn(location.state);

  const handleNavtoWebinar = () => {
    navigate(-1);
  };

  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('transcript');

  // Function to handle tab change
  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  //start process
  const [loading, setLoading] = useState(true); // New loading state
  const [webinar, setWebinar] = useState(null);
  const [webinarQualityKpi, setWebinarQualityKpi] = useState(null);
  const [webinarOverAllSummary, setWebinarOverAllSummary] = useState(null);
  const [webinarTopics, setWebinarTopics] = useState(null);
  const [webinarSummary, setWebinarSummary] = useState(null);
  const [redflag, setRedflags] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const payload = {
          webinar_id: state.id,
        };

        // console.log('Payload:', payload);
        const response = await axios.post(
          process.env.REACT_APP_API_LINC_FELLOW_BASE_URL + 'webinar/view_webinar',
          payload,
        );
        // console.log('API Response:', response);

        // if(response?.data){
        setWebinar(response?.data || null);
        const r_flag_res = JSON.parse(response?.data?.session_analysis?.webinar_quality_analysis?.red_flags)
        const flags = [
                { label: "Poor Call Quality", value: r_flag_res?.poor_call_quality },
                { label: "Student Upset", value: r_flag_res?.student_upset },
                { label: "Student Dissatisfaction", value: r_flag_res?.student_dissatisfaction },
                { label: "Unprofessional Language", value: r_flag_res?.unprofessional_language },
              ]
                .filter(flag => flag.value)
                .map(flag => flag.label);
        const reason = flags.length>0 ? r_flag_res.reason : null
        
        setRedflags({
          flags,
          reason
        })
        const responseteach = response?.data || null;
        console.warn("responseteach ", responseteach)
        // Extract webinar quality values
        const webinarQuality =
          responseteach?.session_analysis?.webinar_quality_analysis || {};
        const overallSessionScore =
          webinarQuality?.overall_session_quality_score ?? 0;
        const clarityScore = webinarQuality?.clarity_score ?? 0;
        const webinarCoverScore = webinarQuality?.webinar_coverage_score ?? 0;
        const webinarEngagementcore =
          webinarQuality?.instructor_engagement_score ?? 0;
        const studentSentimentScore =
          webinarQuality?.student_sentiment_score ?? 0;
        const TimeSpokenScore = webinarQuality?.time_spoken_by_teacher ?? 0;
        const fluencyScore = webinarQuality?.fluency_score ?? 0;
        const responsiveness_score = webinarQuality?.responsiveness_score ?? 0;
        // setWebinarQualityKpi(responseteach?.webinar_quality.kpi)
        setWebinarOverAllSummary(responseteach?.session_analysis || null);
        // setWebinarQualityKpi(responseteach?.webinar_quality.kpi)
        setWebinarQualityKpi(
          responseteach?.session_analysis?.kpi?.replace(
            /className=/g,
            'class=',
          ),
        );
        setWebinarTopics(responseteach?.topic_and_queries || null);
        // setWebinarStudentQuestions(responseteach?.studentQuestion)
        setWebinarSummary(responseteach?.summary || null);
        // setteachername(responseteach);
        // setWebinarStudentIssues(responseteach.studentIssues)

        // Update Progress Bar Options Dynamiwebinary
        setProgressOptions((prevOptions) => ({
          ...prevOptions,
          series: [
            {
              name: 'Scores',
              color: '#fff',
              pointWidth: 10,
              data: [
                {
                  y: overallSessionScore,
                  color: getColorByScore(overallSessionScore),
                },
                {
                  y: clarityScore,
                  color: getColorByScore(clarityScore),
                },
                {
                  y: webinarCoverScore,
                  color: getColorByScore(webinarCoverScore),
                },
                {
                  y: webinarEngagementcore,
                  color: getColorByScore(webinarEngagementcore),
                },
                {
                  y: studentSentimentScore,
                  color: getColorByScore(studentSentimentScore),
                },
                {
                  y: responsiveness_score,
                  color: getColorByScore(responsiveness_score),
                },
                {
                  y: TimeSpokenScore,
                  color: getColorByScore(TimeSpokenScore),
                },
                {
                  y: fluencyScore,
                  color: getColorByScore(fluencyScore),
                },
              ],
              dataLabels: {
                enabled: true,
                format: '{point.y}',
                style: {
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#000',
                },
              },
            },
          ],
        }));
      } catch (error) {
        console.warn('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [state?.id]);

  // console.log(webinar);

  //Anatic line
  const scores = []; // Example scores

  // const getColorByScore = (score) => {
  //   if (score >= 80) return '#006400'; // Dark Green
  //   if (score >= 50) return '#90EE90'; // Light Green
  //   return '#e88479'; // Yellow
  // };
        const getColorByScore = (score) => ({
        linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
        stops:
          score < 50
            ? [
                [0, '#FFD6D6'], // light red
                [1, '#FF8A8A'],
              ]
            : score < 80
            ? [
                [0, '#FFF7CC'], // light yellow
                [1, '#FFE066'],
              ]
            : [
                [0, '#D1F7C4'], // light green
                [1, '#90EE90'],
              ],
      });


  const [progressOptions, setProgressOptions] = useState({
    chart: {
      type: 'bar',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [
        'Overall Session Quality Score',
        'Clarity Score ',
        'Webinar Coverage Score',
        'Instructor Engagement Score',
        'Student Sentiment',
        'Responsiveness Score (%)',
        'Time Spoken by the Teacher (%)',
        'Fluency Score (%)',
      ],
    },
    yAxis: {
      width: '90%',
      title: {
        text: '',
      },
      max: 100,
    },
    series: [
      {
        name: 'Scores',
        color: '#fff',
        pointWidth: 15,
        data: scores.map((score) => ({
          y: score,
          //   color: getColorByScore(score),
          color: getColorByScore(score),
        })),
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          style: {
            fontSize: '12px',
            fontWeight: 'bold',
            color: '#000',
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Aggregate Session Analysis',
        },
      },
    },
  });

  const rows = [
    {
      label: 'Agenda Defined',
      value: webinarSummary?.content_coverage?.is_agenda_defined,
      title: 'Did the instructor define an agenda at the start of the session',
    },
    {
      label: 'Participation Encouraged',
      value: webinarSummary?.content_coverage?.is_participation_encouraged,
      title:
        'Were the students encouraged to participate in the session / switch on videos',
    },
    {
      label: 'Recap Provided',
      value: webinarSummary?.content_coverage?.is_previous_session_recapped,
      title: 'Did the teacher provide a recap of the previous session',
    },
    {
      label: 'Upcoming Assessment Report',
      value: webinarSummary?.content_coverage?.is_assessment_discussed,
      title: 'Was an upcoming Assessment discussed',
    },
    {
      label: 'LMS Content Referred',
      value: webinarSummary?.content_coverage?.is_lms_content_referred,
      title:
        ' Did the instructor refer to existing content / exercises on the LMS when presenting',
    },
    {
      label: 'Session Summarized',
      value: webinarSummary?.content_coverage?.is_session_summarized,
      title:
        'Did the instructor summarise the session before concluding, and provide next steps',
    },
    {
      label: 'Slides Used',
      value: webinarSummary?.content_coverage?.is_slides_used,
      title: 'Did the instructor use any slides during the session',
    },
    {
      label: 'Interactive Tools Used',
      value: webinarSummary?.content_coverage?.is_interactive_tool_used,
      title: 'Did the instructor use any interactive tools (like Kahoot, etc.)',
    },
    {
      label: 'Connectivity Issues',
      value: webinarSummary?.content_coverage?.is_connectivity_issue,
      title:
        'Did the instructor face any connectivity issue during the webinar',
    },
  ];
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // If webinar data is not yet available, render a loading state
  // if (!webinar) {
  //   return <div>Loading...</div>;
  // }

  // const formattedAudioDataArray = webinar?.transcription.map((audio, index) => {
  //   // Extract unique speaker names from the transcription data
  //   const speakerNames = [
  //     ...new Set(webinar.transcription.map((line) => line.speaker)),
  //   ];

  //   // Map the transcription data to assign speaker classes dynamiwebinary
  //   return webinar.transcription.map((line, index1) => ({
  //     //speakerClass: line.speaker === speakerNames[0] ? "speaker-a" : "speaker-b", // Assign class based on the first speaker name
  //     speakerClass: index1 % 2 == 0 ? 'speaker-a' : 'speaker-b', // Even index: speaker-a, Odd index: speaker-b
  //     text: line.text, // The actual transcription text
  //     speaker: line.speaker,
  //     start: Math.round(parseFloat(line.start) * 100) / 100, // Rounded to 2 decimal places
  //     end: Math.round(parseFloat(line.end) * 100) / 100, // Rounded to 2 decimal places
  //   }));
  // });

  const formattedAudioDataArray = webinar?.transcription.map((audio, index) => {
    // Extract unique speaker names from the transcription data
    const speakerNames = [
      ...new Set(webinar.transcription.map((line) => line.speaker)),
    ];

    const teacher_name = webinar?.teacher_name.trim().toLowerCase() || '';
    // Map the transcription data to assign speaker classes dynamiwebinary
    return webinar.transcription.map((line, index1) => ({
      //speakerClass: line.speaker === speakerNames[0] ? "speaker-a" : "speaker-b", // Assign class based on the first speaker name
      speakerClass:
        teacher_name == line.speaker.trim().toLowerCase()
          ? 'speaker-b'
          : 'speaker-a', // Even index: speaker-a, Odd index: speaker-b
      text: line.text, // The actual transcription text
      speaker: line.speaker,
      start: Math.round(parseFloat(line.start) * 100) / 100, // Rounded to 2 decimal places
      end: Math.round(parseFloat(line.end) * 100) / 100, // Rounded to 2 decimal places
    }));
  });

  const formatHtmlBold = (html) => {
    if (!html) return '<p>No Data.</p>';

    // Add class="bold" to all <h1> to <h6> tags
    return html.replace(/<h([1-6])(.*?)>/g, '<h$1 class="bold"$2>');
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div className="d-flex gap-2 align-items-center mb-2">
            <Button
              onClick={handleNavtoWebinar}
              className="mb-0 back-arrow-btn"
            >
              <i className="fas fa-arrow-left"></i>
            </Button>

            <h3 className="bold mb-0 ml-2">Webinar Analytics Report</h3>
          </div>
          <div className="ind-teacher-report-tab">
            <Nav className="mb-0" tabs>
              <NavItem>
                <NavLink
                  className={activeTab === 'transcript' ? 'active' : ''}
                  active={activeTab === 'transcript'}
                  onClick={() => toggleTab('transcript')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Transcript
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'summary' ? 'active' : ''}
                  active={activeTab === 'summary'}
                  onClick={() => toggleTab('summary')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Webinar Summary
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'topics' ? 'active' : ''}
                  active={activeTab === 'topics'}
                  onClick={() => toggleTab('topics')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Topics and Queries
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'session' ? 'active' : ''}
                  active={activeTab === 'session'}
                  onClick={() => toggleTab('session')}
                  style={{ cursor: 'pointer', marginRight: '2px' }}
                >
                  Session Analysis
                </NavLink>
              </NavItem>
               <NavItem>
                  <NavLink
                    className={activeTab === 'redflages' ? 'active' : ''}
                    active={activeTab === 'redflages'}
                    onClick={() => toggleTab('redflages')}
                    style={{ cursor: 'pointer', marginRight: '3px' }}
                  >
                    Red Flags
                  </NavLink>
                </NavItem>
            </Nav>

            {activeTab === 'transcript' && (
              <Card
                className="border box-shadow-none mb-0"
                style={{ borderTopLeftRadius: '0px' }}
              >
                <CardBody>
                  <div className="va-info-wrapper">
                    <div className="d-flex flex-column flex-grow-1 overflow-auto p-3">
                      {formattedAudioDataArray &&
                        formattedAudioDataArray[0] &&
                        formattedAudioDataArray[0].map((line, index) => (
                          <div
                            key={index}
                            className={`chat-bubble ${line.speakerClass}`}
                          >
                            <strong>{line.speaker}</strong>
                            <br />
                            {line.text}
                            <br />
                            <span>
                              {line.start}m - {line.end}m
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                </CardBody>
              </Card>
            )}

            {activeTab === 'summary' && (
              <Card className="border box-shadow-none mb-0">
                <CardBody>
                  <div className="va-info-wrapper">
                    <h5 className="f-18 d-flex bold">Webinar Summary</h5>
                    <div className="mt-2">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            webinarSummary?.webinar_summary ||
                            '<p>No Data.</p>',
                        }}
                      />
                    </div>
                    <h5 className="f-18 d-flex bold">Content Coverage</h5>
                    <div className="mt-2">
                      <table className="bordered-table">
                        <tbody>
                          {webinarSummary &&
                            rows.map((row, index) => (
                              <tr key={index}>
                                <td>
                                  <span
                                    className="position-relative d-inline-block"
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {row.label}
                                    {hoveredIndex === index && (
                                      <span className="tooltip-box">
                                        {row.title}
                                      </span>
                                    )}
                                  </span>
                                </td>
                                <td>{row.value}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    {/* <br></br>
                      <h4 className="bold mt-2"> Knowledge Gaps Identified /  Common Doubts Raised by student		</h4>
                      <div className="mt-2">
                      <div dangerouslySetInnerHTML={{ __html: webinarSummary.knowledge_gaps_identified }} />
                      </div> */}
                    <br />
                    <br />
                    <br /> <br />
                    <br />
                    <br />
                  </div>
                </CardBody>
              </Card>
            )}

            {activeTab === 'topics' && (
              <Card className="border box-shadow-none mb-0">
                <CardBody>
                  <div className="va-info-wrapper">
                

                    <h5 className="f-18 d-flex bold mt-2">
                      Topics Covered by Instructor
                    </h5>
                    <div className="mt-2 pl-2">
                      

                        {webinarTopics?.topics_covered_by_instructor &&
                          Object.entries(webinarTopics?.topics_covered_by_instructor).map(
                            ([topicName, qas], index) => (
                              <div key={index} className="mb-3">
                                <h6><strong>
                                    Topic:
                                   </strong> {topicName}</h6>
                                {qas.map((qa, qaIndex) => (
                                  <div key={qaIndex} className="mb-2">
                                    <p>
                                      <strong>Query:</strong> {qa.query}
                                    </p>
                                    <p>
                                      <strong>Response:</strong> {qa.response}
                                    </p>

                                    {/* Show A Mark if is_assessment_related is true */}
                                    {qa.is_assessment_related && (
                                      <p className="text-success">
                                        <strong>A :</strong> ✓ Assessment
                                        Related
                                      </p>
                                    )}
                                  </div>
                                ))}
                              </div>
                            ),
                          )}



                    </div>

                    <h5 className="f-18 d-flex bold mt-2">Student Issues</h5>
                    <div className="mt-2">
                      {webinarTopics?.student_issues &&
                      webinarTopics.student_issues.length > 0 ? (
                        webinarTopics.student_issues.map((issue, index) => (
                          <div
                            key={index}
                            dangerouslySetInnerHTML={{ __html: issue }}
                            className="mb-2"
                          />
                        ))
                      ) : (
                        <p>No Student Issue Available</p>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            )}

            {activeTab === 'session' && (
              <Card className="border box-shadow-none mb-0">
                <CardBody>
                  <div className="va-info-wrapper">
                    <div>
                      {loading ? ( // Show loader while loading
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: '200px' }}
                        >
                          <Spinner style={{ width: '3rem', height: '3rem' }} />
                        </div>
                      ) : (
                        <>
                          <h5 className="f-18 d-flex bold mb-3 ">
                            Summary Analysis{' '}
                          </h5>
                           <p className="mb-3">
                            <strong>Total Webinar Duration:</strong>{' '}
                            {webinarOverAllSummary?.total_webinar_duration ||
                              '0'}
                          </p>
                          <div>
                            <h5 className="f-18 d-flex bold">Strengths</h5>
                            <div
                              className="mt-2"
                              dangerouslySetInnerHTML={{
                                __html:
                                  webinarOverAllSummary?.strengths ||
                                  '<p>No Data.</p>',
                              }}
                            />
                            <h5 className="f-18 d-flex bold">
                              Areas of Improvement
                            </h5>
                            <div
                              className="mt-2"
                              dangerouslySetInnerHTML={{
                                __html:
                                  webinarOverAllSummary?.area_of_improvements ||
                                  '<p>No Data.</p>',
                              }}
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div className="my-2 h-100 ">
                      {loading ? ( // Show loader while loading
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: '200px' }}
                        >
                          <Spinner style={{ width: '3rem', height: '3rem' }} />
                        </div>
                      ) : (
                        <>
                          <h5 className="f-18 d-flex  bold mb-3 ">
                            Aggregated Analysis of Sessions{' '}
                          </h5>
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={progressOptions}
                          />
                        </>
                      )}
                    </div>
                    <div
                      className="mt-2"
                      dangerouslySetInnerHTML={{
                        __html: formatHtmlBold(
                          webinarQualityKpi || '<p>No Data.</p>',
                        ),
                      }}
                    />
                  </div>
                </CardBody>
              </Card>
            )}

            {activeTab === 'redflages' && (
              <div>
                <Card
                  className="border box-shadow-none mb-0"
                  style={{ borderTopLeftRadius: '0' }}
                >
                  <CardBody className="border" style={{ minHeight: '500px' }}>
                    <div className="va-info-wrapper">
                      <div className="mt-2">
                        <h5 className="f-16 d-flex  bold mb-3">Red Flags</h5>
                        {/* FLAGS SECTION */}
                        {redflag?.flags?.length > 0 ? (
                          <>
                            <ul>
                              {redflag.flags.map((flag, index) => (
                                <li key={index}>{flag}</li>
                              ))}
                            </ul>
                          </>
                        ) : (
                          <p className="f-14 d-flex mb-3">No Flags Identified</p>
                        )}

                        {/* REASON SECTION */}
                        <h5 className="f-16 d-flex  bold mb-3">Reason</h5>
                        <div
                          className="mt-2"
                          dangerouslySetInnerHTML={{
                            __html:
                              redflag?.reason ||
                              '<p>No Reasons Available.</p>',
                          }}
                        />

                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            )}

          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Inbox;
